export interface PaymentWithCardOnFileRequestDto {
  orderId?: string;
  token: string;
  merchantId: string;
}
